/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import dayjs from "dayjs";
import Config from "data/config";
import { getPrimaryDate, hasPrimaryDate } from "cms/models/helpers";

const ResultItem = (props) => {
    
    const { model } = props;
    if (!model) {
        return;
    }
    const {
        guid,
        title,
        description,
        // path
    } = model;
    const hasDate = hasPrimaryDate(model);
    let primary_date;
    if (hasDate) {
        const dateData = getPrimaryDate(model);
        // const updated_at = model?.updated_at
        // const { date = updated_at } = dateData || {}
        const { date } = dateData || {};
        primary_date = date ? dayjs(date).format(Config.dates.display.date) : undefined;
    }
    
    return (
        <div className="views-row views-row-1 views-row-odd views-row-first">
            <div className="ds-1col node node-news node-promoted node-teaser view-mode-teaser clearfix">
                <h3 className="title">
                    <a href={`/composer/${guid}`}>
                        {title}
                    </a>
                </h3>
                {primary_date &&
                    <div className="field field-name-post-date" style={{ fontWeight: "700" }}>
                        {primary_date}
                    </div>
                }
                <div className="field field-name-field-content" style={{ marginBottom: "36px" }}>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
};

export { ResultItem };
